import React, { FC, ReactNode, useContext } from 'react'
import s from './Cover.module.sass'
import { ImgContext } from '@shared/ui/Layout/Cover/Cover'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { MediaImg } from '@shared/ui/Media/MediaImg'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  children: ReactNode
  className?: string
  alt?: string
}

const CoverMain: FC<Props> = ({ children, className = '', alt = 'image cover blur' }) => {
  const imgSrc = useContext(ImgContext)
  const { isMobile } = useClientResponsive()
  return (
    <ErrorBoundary>
      <main className={`${s.main} ${className}`}>
        <div className={s['main-blur-wrapper']}>
          <div className={s['main-blur']}>
            {!isMobile && (
              <MediaImg
                image={{
                  Url: imgSrc,
                  Width: 40,
                  Height: 40,
                  Crop: null,
                  Description: alt,
                  Copyright: null,
                  Author: null,
                }}
                objectId={Number(imgSrc)}
                height={40}
                width={40}
                flexible={true}
                className={s.img}
              />
            )}
          </div>
        </div>

        {children}
      </main>
    </ErrorBoundary>
  )
}

export default CoverMain
